import React from "react";
import SharedHelmet from './Helmet'
const TITLE = "Tentang Situs Ahsib";
const DESCRIPTION = "Ahsib adalah platform Arab terbesar yang menyediakan lebih dari 2000 kalkulator online gratis untuk membantu Anda melakukan perhitungan dengan cepat dan akurat di berbagai bidang seperti keuangan, kebugaran, kesehatan, matematika, fisika, dan lainnya.";
const KEYWORDS = "Ahsib, kalkulator, kalkulator gratis, matematika, keuangan, kebugaran, fisika, perhitungan, Arab, kalkulator online";
const OG_URL = "https://do-calculate.com/id/about/";
const About = () => {
  return (
    <div dir="ltr">
      <SharedHelmet
             TITLE={TITLE}
             DESCRIPTION={DESCRIPTION}
             KEYWORDS={KEYWORDS}
             OG_URL={OG_URL}
           />
      <div className="p-3 mb-2 bg-success text-white">
        <h1 style={{ fontSize: '24px', marginBottom: '15px' }}>
          <b>Tentang Situs "Ahsib"</b>
        </h1>
      </div>
      <p style={{ lineHeight: '1.6' }}>
        Situs "Ahsib" adalah platform Arab terbesar yang mengkhususkan diri dalam menyediakan lebih dari 2000 kalkulator online gratis. Kami menawarkan berbagai macam kalkulator yang meliputi matematika, keuangan, kebugaran, kesehatan, fisika, dan lainnya. Platform kami bertujuan untuk memudahkan melakukan perhitungan cepat dan akurat di berbagai bidang, serta menyediakan informasi mendalam tentang setiap kalkulator.
        <br/>        Lebih dari 92% kalkulator kami didasarkan pada rumus dan persamaan yang dikenal dari buku pelajaran, seperti kalkulator Indeks Massa Tubuh (BMI), dan lainnya. Jika rumusnya kontroversial, kami menyajikan hasil dari semua rumus yang umum, seperti halnya pada kalkulator berat badan ideal.
        <br/>        Kami fokus secara eksklusif pada penyediaan kalkulator online yang cepat, komprehensif, nyaman, dan gratis di berbagai bidang. Tujuan kami adalah menjadi situs Arab pertama yang dituju orang untuk melakukan perhitungan cepat. Selain itu, kami percaya bahwa internet harus menjadi sumber informasi gratis, oleh karena itu semua alat dan layanan kami sepenuhnya gratis, dan tidak memerlukan pendaftaran apa pun.
        <br/>        Kami telah berusaha keras untuk memastikan bahwa semua kalkulator berfungsi dengan benar. Namun, jika Anda menemukan kesalahan kecil atau memiliki saran untuk meningkatkan layanan kami, harap beri tahu kami.
      </p>
      <hr />
      <div className="p-3 mb-2 bg-success text-white">
        <p style={{ lineHeight: '1.6' }}>
          Jika Anda memiliki pertanyaan, ingin tim kami menambahkan kalkulator baru, atau ingin melaporkan masalah pada salah satu kalkulator, silakan hubungi kami melalui email berikut:
          <br />
          <a href="mailto:info@do-calculate.com" style={{ color: 'white', textDecoration: 'underline' }}>info@do-calculate.com</a>
        </p>
      </div>
    </div>
  );
};
export default About;